import { createStore, applyMiddleware, combineReducers as compose } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";


const middleware = applyMiddleware();

const enhancers =
    process.env.NODE_ENV === "development" ? composeWithDevTools({})(middleware) : middleware;

export default createStore(compose({}), {}, enhancers);